import React, { useState, useEffect, useRef, Fragment } from 'react';
import { Overlay } from 'components';
import { mount } from './mount';

export const ButtonModal = mount('app-button-modal', props => {

  const [ overlay, setOverlay ] = useState();
  const [ content, setContent ] = useState();

  const ref = useRef();

  useEffect(() => {
    const button = ref.current.parentNode.parentNode.parentNode;
    const id = button.getAttribute('href');
    setContent(window.document.getElementById(id).innerHTML);
    button.addEventListener('click', () => setOverlay(true));
  }, []);

  return (
    <Fragment>
      <span ref={ref} dangerouslySetInnerHTML={{__html: props.innerHTML }} />
      <Overlay overlay={overlay} close={() => setOverlay(false)}>
        <div dangerouslySetInnerHTML={{__html: content }} />
      </Overlay>
    </Fragment>
  );
});

